import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fcst",
  "use": "icon-fcst-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fcst\"><path d=\"M704 192v384H257.6c-24 0-46.4 6.4-65.6 17.6V256.8c0-36 28.8-64.8 64.8-64.8H704m64-64H256.8C185.6 128 128 185.6 128 256.8v510.4c0 71.2 57.6 128.8 128.8 128.8H896V192h-64v640H257.6c-36 0-65.6-29.6-65.6-65.6v-60.8c0-36 29.6-65.6 65.6-65.6H768V128z m0 576H256v64h512v-64z\" p-id=\"5249\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol